import React, { useEffect } from 'react';
import { useTitle } from "../../../contexts/title";
import AssignedDistributorsGrid from '../../../features/cfi/assigned-distributors-grid/components/AssignedDistributorsGrid';

export default function AssignedDistributorsPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Assigned Distributors')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<AssignedDistributorsGrid />
			</div>
		</React.Fragment>
	)
} 
